import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Typography
} from "@mui/material";
import localStrings from "../localStrings";

const NotFound = () => (
  <>
    <Helmet>
      <title>{localStrings.notFound}</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="md">
        <Typography
          align="center"
          color="textPrimary"
          variant="h1"
        >
          {localStrings.notFoundMessageOne}

        </Typography>
        <Typography
          align="center"
          color="textPrimary"
          variant="subtitle2"
        >
          {localStrings.notFoundMessageTwo}
        </Typography>
        <Box sx={{ textAlign: 'center' }}>
          <img
            alt="Under development"
            src="/static/images/undraw_page_not_found_su7k.svg"
            style={{
              marginTop: 50,
              display: 'inline-block',
              maxWidth: '100%',
              width: 560
            }}
          />
        </Box>
      </Container>
    </Box>
  </>
);

export default NotFound;
